import * as localStorageKeys from '../constants/localStorageKeys';
import oemManager from '../services/oem';
import { getFileExtension } from '../services/mediaStore/src/utils';
import { httpConfigWithOt } from 'lib/opentelemetry/utils';

const getCloudPluginEnvToken = () => {
    return oemManager.oem.getXApp();
};

export const axiosConfig = () => {
    const ind = localStorage.getItem(localStorageKeys.IDENTITY);
    const indSign = localStorage.getItem(localStorageKeys.IDENTITY_SIGNATURE);

    return {
        headers: {
            'MMSAuth': ind,
            'MMSAuthSig': indSign,
            'Content-Type': 'application/json;charset=UTF-8',
        },
    };
};

/**
 * Creates a configuration object for requests to the cloud, including headers.
 * Retrieves the cloud token from local storage and sets it as a Bearer token in the 'authorization' header.
 *
 * @returns {Object} A configuration object containing request headers.
 */
export const axiosCloudConfig = () => {
    const cloudToken = localStorage.getItem(localStorageKeys.CLOUD_TOKEN);

    return {
        headers: {
            'authorization': `Bearer ${cloudToken}`,
            'Content-Type': 'application/json;charset=UTF-8',
        },
    };
};

export const axiosCloudConfigDownload = () => {
    const cloudToken = localStorage.getItem(localStorageKeys.CLOUD_TOKEN);

    return {
        headers: {
            authorization: `Bearer ${cloudToken}`,
        },
    };
};

export const axiosCloudPlugin = () => {
    const cloudToken = localStorage.getItem(localStorageKeys.CLOUD_TOKEN);

    return {
        headers: {
            'Authorization': `Bearer ${cloudToken}`,
            'X-APP': getCloudPluginEnvToken(),
        },
    };
};

export const axiosCloudFile = (updatedFile) => {
    const cloudToken = localStorage.getItem(localStorageKeys.CLOUD_TOKEN);
    const fileFormat = getFileExtension(updatedFile);

    return {
        headers: {
            'Authorization': `Bearer ${cloudToken}`,
            'X-APP': getCloudPluginEnvToken(),
            'p-owner_entity_type': 'user',
            'p-bucket': 'media',
            'p-type': 'multimedia',
            'p-file_format': fileFormat,
            'p-filename': `logo.${fileFormat}`,
        },
    };
};

export const MMSAuthHeadersConfig = () => {
    const ind = localStorage.getItem(localStorageKeys.IDENTITY);
    const indSign = localStorage.getItem(localStorageKeys.IDENTITY_SIGNATURE);

    return {
        headers: {
            MMSAuth: ind,
            MMSAuthSig: indSign,
        },
    };
};

export const axiosKVSConfig = (authorization) => {
    return {
        headers: {
            'Content-Type': 'application/vnd.api+json',
            'Authorization': `Basic ${authorization}`,
        },
    };
};

/**
 * Generates a simple configuration object with authentication headers from localStorage.
 * @param {Object} [options={}] - Additional headers to include in the request.
 * @returns {Object} - Axios-compatible configuration object with headers.
 */
export const simpleConfig = (options = {}) => {
    const ind = localStorage.getItem(localStorageKeys.IDENTITY);
    const indSign = localStorage.getItem(localStorageKeys.IDENTITY_SIGNATURE);

    return {
        headers: {
            ...options,
            MMSAuth: ind,
            MMSAuthSig: indSign,
        },
    };
};
/**
 * Builds an OpenTelemetry-wrapped configuration using `axiosConfig`.
 * @type {Function}
 */
export const buildAxiosConfig = httpConfigWithOt(axiosConfig);
/**
 * Builds an OpenTelemetry-wrapped configuration using `simpleConfig`.
 * @type {Function}
 */
export const buildSimpleConfig = httpConfigWithOt(simpleConfig);
/**
 * Builds an OpenTelemetry-wrapped configuration using `MMSAuthHeadersConfig`.
 * @type {Function}
 */
export const buildMMSAuthHeadersConfig = httpConfigWithOt(MMSAuthHeadersConfig);
/**
 * Builds an OpenTelemetry-wrapped configuration using `axiosCloudPlugin`.
 * @type {Function}
 */
export const buildAxiosCloudPlugin = httpConfigWithOt(axiosCloudPlugin);
